/**
 * Limpa todos os storages relacionados à sessão do usuário
 * Esta função deve ser chamada ao fazer login, logout ou register
 */
export function clearUserSessionStores(): void {
  localStorage.removeItem("speeke-agent")
  localStorage.removeItem("speeke-pipeline")
  console.log("User session stores cleared")
}

/**
 * Limpa todos os dados persistidos da aplicação
 * Útil para resetar completamente o estado em situações especiais
 */
export function clearAllPersistentStores(): void {
  // Obter todas as chaves do localStorage
  const keys = Object.keys(localStorage)

  // Filtrar apenas as chaves relacionadas ao Zustand e ao app
  const appKeys = keys.filter(
    key =>
      key.endsWith("-storage") || // Padrão de nomeação Zustand
      key.startsWith("speeke-") || // Prefixo da aplicação
      key.includes("zustand") // Possível prefixo Zustand
  )

  // Remover todos os itens filtrados
  appKeys.forEach(key => localStorage.removeItem(key))

  console.log(`Cleared ${appKeys.length} persistent stores`)
}
